import { Tag, Space, Button, Tooltip, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { STORES } from "../BlogsTable/stores";

const labelForHash = (hash) =>
  STORES.find((s) => s.hash === hash)?.label || "";

const formatRelative = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  const sec = Math.round(diffMs / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} hour${hr === 1 ? "" : "s"} ago`;
  const day = Math.round(hr / 24);
  if (day < 30) return `${day} day${day === 1 ? "" : "s"} ago`;
  return d.toLocaleDateString("en-GB");
};

const buildColumns = ({ onEdit, onDelete, page = 1, limit = 10 }) => [
  {
    title: "Sr. No",
    key: "sno",
    width: 80,
    align: "center",
    render: (_, __, index) => (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {(page - 1) * limit + index + 1}
      </Typography.Text>
    ),
  },
  {
    title: "Store",
    dataIndex: "storeHash",
    key: "storeHash",
    width: 170,
    sorter: (a, b) => labelForHash(a.storeHash).localeCompare(labelForHash(b.storeHash)),
    render: (val) => {
      const label = labelForHash(val);
      return (
        <Space size={4} direction="vertical" style={{ lineHeight: 1.2 }}>
          {label ? (
            <Tag color="geekblue" style={{ marginRight: 0 }}>
              {label}
            </Tag>
          ) : (
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>
              Unknown store
            </Typography.Text>
          )}
          <Tooltip title={val}>
            <Typography.Text code style={{ fontSize: 11 }}>
              {val || "—"}
            </Typography.Text>
          </Tooltip>
        </Space>
      );
    },
  },
  {
    title: "Type Name",
    dataIndex: "typeName",
    key: "typeName",
    ellipsis: true,
    sorter: (a, b) => String(a.typeName || "").localeCompare(String(b.typeName || "")),
    render: (val) => <Typography.Text>{val}</Typography.Text>,
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 130,
    align: "center",
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    render: (val) => (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {formatRelative(val)}
      </Typography.Text>
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 120,
    fixed: "right",
    align: "center",
    render: (_, record) => (
      <Space onClick={(e) => e.stopPropagation()}>
        <Tooltip title="Edit">
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
          />
        </Tooltip>
        <Tooltip title="Delete permanently">
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete?.(record)}
          />
        </Tooltip>
      </Space>
    ),
  },
];

export default buildColumns;
